import { ui_machine_translations_french } from './ui_machine_french';

export const ui_machine_translations_french_belgian = {
    ...ui_machine_translations_french,
    "Consider rewording your perspective label:":"Pouvez-vous reformuler l'étiquette de votre perspective ?",
    "⚠️ Check your perspective label":"⚠️ Vérifiez l'étiquette de votre perspective",
    "Lower priority":"Priorité inférieure",
}   